import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'flatpickr/dist/flatpickr.css';
import $ from 'jquery';
window.$ = window.jQuery = $;
import './scripts/yearpicker.js';
import './scripts/custom.js';


const container = document.getElementById('landing-root');

// const basePath = (process.env.MIX_REACT_BASEPATH || '').replace(/\/+$/, '');
const basePath = process.env.MIX_REACT_BASEPATH || "";

if (container) {
    const root = createRoot(container);

    root.render(
        <BrowserRouter basename={basePath}>
            <Router />
        </BrowserRouter>
    );
}